// -- Framework imports --
import type { App, Plugin } from 'vue';
import { AxiosResponse } from 'axios';

// -- Define plugin --
const DownloadPlugin: Plugin = {
	install: (app: App) => {
		app.config.globalProperties.$downloads = $downloads;
	},
};

// -- Global downloads interface available in app --
const $downloads = {
	downloadAxiosResponse: (res: AxiosResponse, filename: string | undefined = undefined) => {
		const dataType = ((res.headers['content-type'] as string) || 'text/plain').replace(/\s/, '');
		const data = encodeURI(`data:${dataType};base64,` + btoa(res.data));
		const link = document.createElement('a');

		// Figure out filename by request
		if (!filename) {
			if (!!res.request && 'responseURL' in res.request) {
				filename = res.request.responseURL.replace(/^.+\//, '');
			}
		}

		if (filename) {
			link.setAttribute('download', filename);
		}

		link.setAttribute('href', data);
		link.click();
	},
};

// -- Exports --
export default DownloadPlugin;

export { $downloads };

declare module '@vue/runtime-core' {
	export interface ComponentCustomProperties {
		$downloads: typeof $downloads;
	}
}
